/* eslint-disable */ 

export default {
    editorChoices: {
      error:'',
      loading:true,
      data:[]
    }
   
  }